import { Controller } from '@hotwired/stimulus';

export default class SymbolFieldController extends Controller {
  static targets = [
    'source',
    'field',
  ];

  declare readonly fieldTarget:HTMLInputElement;
  declare readonly sourceTarget:HTMLInputElement;
  declare locked:boolean;

  connect() {
    this.setLocked();
  }

  generateSymbol(source:String):string {
    let symbol = source.toLowerCase();
    symbol = symbol.replace(/[^\p{L}\d]+/gu, '_');
    symbol = symbol.replace(/^[_\d]*|_+$/gu, '');
    return symbol;
  }

  onSourceInput(event:Event) {
    if (this.locked || this.fieldTarget.readOnly) return;

    this.fieldTarget.value = this.generateSymbol(this.sourceTarget.value);
  }

  onFieldInput(event:Event) {
    this.setLocked();
  }

  setLocked() {
    this.locked = (this.fieldTarget.value !== '' && this.fieldTarget.value !== this.generateSymbol(this.sourceTarget.value));
  }

  fieldTargetConnected(element:HTMLElement) {
    element.dataset.action = 'symbol-field#onFieldInput';
    let from = element.dataset.symbolFieldFrom;
    if (from) {
      let fromEl = this.element.querySelector(from) as HTMLElement;
      if (fromEl) {
        fromEl.dataset.symbolFieldTarget = 'source';
        fromEl.dataset.action = 'symbol-field#onSourceInput';
        let fromContainer = fromEl.closest('.form--field');
        let sourceContainer = element.closest('.form--field');
        if (fromContainer && sourceContainer) {
          fromContainer.parentElement?.insertBefore(sourceContainer, fromContainer.nextElementSibling);
        }
      }
    }
  }
}
